
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Viele Menschen sind nach dem Aufwachen überzeugt, dass sie «kein Auge» zugetan haben. Messungen der Gehirnaktivitäten zeigen aber, dass diese Überzeugung rein subjektiv ist. Selbst Menschen, die unter schwerer Schlaflosigkeit leiden, schlafen mehrere Stunden pro Nacht. Der Grund: Wer unter Schlafproblemen leidet, hat mehr Leichtschlafphasen und kürzere Tiefschlafphasen, nach denen er häufig für ein paar Momente aufwacht. Dieses Aufwachen wird bewusst wahrgenommen («ich bin immer noch wach»), während das darauffolgende Einschlafen unbewusst abläuft. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;